import React from "react";
import {
  Modal,
  Fade,
  Backdrop,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export default function ErrorModal({ open, data = [], onClose, msg }) {

  return (
    <Modal
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            border: "none",
            maxHeight: "70vh",
            overflowY: "auto", // ✅ scroll if too many errors
          }}
        >
          {/* Title */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              id="error-modal-title"
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "rgba(29, 57, 105, 1)",
              }}
            >
              {msg}
              <PriorityHighIcon
                sx={{ color: "#cc3300", fontSize: "18px", ml: 1 }}
              />
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Error list */}
          <Box id="error-modal-description">
            {data.length > 0 ? (
              data.map((err, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  sx={{ mb: 1, color: "#cc3300" }}
                >
                  • {err}
                </Typography>
              ))
            ) : (
              <Typography variant="body2">
                No error details provided.
              </Typography>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
